module.exports = __webpack_public_path__ + "img/hometh3.1b3649b4.png";